var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5026 8.0015V22.1082C13.5026 24.8948 11.4626 27.3748 8.68927 27.6415C5.5026 27.9482 2.83594 25.4548 2.83594 22.3348V5.85483C2.83594 4.10816 4.08927 2.5215 5.8226 2.34816C7.8226 2.14816 9.5026 3.70816 9.5026 5.66816V19.6682C9.5026 20.4015 8.9026 21.0015 8.16927 21.0015C7.43594 21.0015 6.83594 20.4015 6.83594 19.6682V8.0015C6.83594 7.45483 6.3826 7.0015 5.83594 7.0015C5.28927 7.0015 4.83594 7.45483 4.83594 8.0015V19.4815C4.83594 21.2282 6.08927 22.8148 7.8226 22.9882C9.8226 23.1882 11.5026 21.6282 11.5026 19.6682V5.89483C11.5026 3.10816 9.4626 0.628163 6.68927 0.361497C3.51594 0.0548301 0.835938 2.54816 0.835938 5.66816V22.0282C0.835938 25.8548 3.63594 29.2815 7.44927 29.6415C11.8359 30.0415 15.5026 26.6282 15.5026 22.3348V8.0015C15.5026 7.45483 15.0493 7.0015 14.5026 7.0015C13.9559 7.0015 13.5026 7.45483 13.5026 8.0015Z",
    fill: "#2BC2F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/Clip.075a45395665f4c53d841be421380b34.svg";
export { ForwardRef as ReactComponent };